import React from 'react';
import { useController } from 'react-hook-form';
import { useTranslate ,useRecordContext} from 'react-admin';
import { Slider, Box, Typography } from '@mui/material';
import { Controller, useFormContext, useWatch } from "react-hook-form";


 const useWatchMainChanged = (watched_column) => {
  const { control } = useFormContext();
    const record       = useRecordContext();          // ← full row data
      const workflowSubcategory   = Number(record?.workflow_subcategory);     // might be undefined



  // Watch the 'editingVehicleMeta' field
  const IsOdsMain = useWatch({
    control,
    name: watched_column,
    defaultValue: "notcorrect",
  });

  return {
    disabled: IsOdsMain == "correct" && workflowSubcategory > 5, // Disable input if 'editingVehicleMeta' is false
    control,
  };
};


export const DriverFaultRateInput = ({ field_meta, source_name,watched_column, ...props }) => {
  const translate = useTranslate();
  const meta = JSON.parse(field_meta);
  const steps = meta.steps || [0, 25, 50, 100]; // Default steps
  const min = Math.min(...steps);
  const max = Math.max(...steps);
  const label = meta.label ? meta.label : translate(source_name);
  const { disabled } = useWatchMainChanged(watched_column);

  const {
    field: { value, onChange, onBlur },
    fieldState: { error },
  } = useController({
    name: source_name,
    rules: {
      required: translate('ra.validation.required'),
      validate: (value) => steps.includes(value) || translate('ra.validation.one_of', { values: steps.join(', ') }),
    },
    defaultValue: "", // Ensures validation triggers correctly
    ...props,
  });

  return (
    <Box
      sx={{
        mt: 1,
        p: 0,
        border: '1px solid #ddd',
        borderRadius: 2,
        backgroundColor: '#f9f9f9',
        width: '100%',
        height: '46px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography variant="body1" sx={{ whiteSpace: 'nowrap', mr: 2, width: '30%' }}>
        {label}
      </Typography>

      <Box sx={{ px: 1, width: '50%' }}>
        <Slider
         disabled={disabled}

          aria-labelledby="driver-fault-rate-slider"
          value={value !== "" ? value : min} // Ensures a valid initial render
          onChange={(_, newValue) => onChange(newValue)}
          onBlur={onBlur} // Ensures validation triggers on blur
          valueLabelDisplay="auto"
          marks={steps.map((value) => ({
            value,
            label: <Typography variant="caption">{`${value}%`}</Typography>,
          }))}
          step={null} // Only allow specified steps
          min={min}
          max={max}
          sx={{ width: '100%' }}
        />
        {error && (
          <Typography variant="caption" color="error">
            {error.message}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
